<template>
  <div class="buttons" style="margin-right: 10px">
    <div v-if="showFlags.close" class="close" @click="onClose">
      <a class="closebutton" href="#"></a>
    </div>
    <div v-if="showFlags.minimize" class="minimize" @click="onMinimize">
      <a class="minimizebutton" href="#"></a>
    </div>
    <div v-if="showFlags.maximize" class="zoom" @click="onMaximize">
      <a class="zoombutton" href="#"></a>
    </div>
  </div>
</template>

<script>
export default {
  // render(createEl) {
  //   return createEl('h1', 'hello');
  // },
  created() {
    //TODO: replace with render function.
    if (this.$listeners.close) {
      this.showFlags.close = true;
    }

    if (this.$listeners.minimize) {
      this.showFlags.minimize = true;
    }

    if (this.$listeners.maximize) {
      this.showFlags.maximize = true;
    }
  },
  data() {
    return {
      showFlags: {
        close: false,
        minimize: false,
        maximize: false,
      },
    };
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onMinimize($event) {
      this.$emit('minimize', $event);
    },
    onMaximize() {
      this.$emit('maximize');
    },
  },
};
</script>

<style scoped>
/* mac style buttons : https://codepen.io/JohJakob/pen/YPxgwo */
.buttons:hover a {
  visibility: visible;
}

.close {
  background: #ff5c5c;
  font-size: 9pt;
  width: 11px;
  height: 11px;
  border: 1px solid #e33e41;
  border-radius: 50%;
  display: inline-block;
}

.close:active {
  background: #c14645;
  border: 1px solid #b03537;
}

.close:active .closebutton {
  color: #4e0002;
}

.closebutton {
  color: #820005;
  visibility: hidden;
  cursor: default;
}

.minimize {
  background: #ffbd4c;
  font-size: 9pt;
  line-height: 11px;
  margin-left: 4px;
  width: 11px;
  height: 11px;
  border: 1px solid #e09e3e;
  border-radius: 50%;
  display: inline-block;
}

.minimize:active {
  background: #c08e38;
  border: 1px solid #af7c33;
}

.minimize:active .minimizebutton {
  color: #5a2607;
}

.minimizebutton {
  color: #9a5518;
  visibility: hidden;
  cursor: default;
}

.zoom {
  background: #00ca56;
  font-size: 9pt;
  line-height: 11px;
  margin-left: 6px;
  width: 11px;
  height: 11px;
  border: 1px solid #14ae46;
  border-radius: 50%;
  display: inline-block;
}

.zoom:active {
  background: #029740;
  border: 1px solid #128435;
}

.zoom:active .zoombutton {
  color: #003107;
}

.zoombutton {
  color: #006519;
  visibility: hidden;
  cursor: default;
}
</style>
